import Vue from 'vue'
import {$projectAnalysis} from '@/services/'

const module = {
  namespaced: true,

  state: {
    items: [],
    item: {},
    meta: { pagination: {}},
    availableModels: []
  },

  getters: {
    items: state => state.items,
    item: state => state.item,
    meta: state => state.meta,
    availableModels: state => state.availableModels
  },

  mutations: {
    ITEMS(state, value){
      state.items = value
    },

    ITEM(state,value){
      state.item = value
    },

    UPDATE(state, {id, data}){
      var index = state.items.findIndex(obj => obj.id == id)
      index > -1 && Vue.set(state.items, index, data)
      if(state.item.id == id){
        state.item = {...state.item, ...data}
      }
    },
    
    DELETE(state, id){
      let index = state.items.findIndex(i => i.id == id)
      index > -1 && state.items.splice(index,1)
    },

    AVAILABLE_MODELS(state, data){
      state.availableModels = data
    },

    RESET(state, payload){
      state.items = state.items.map(item => {
        if(item && item.model_title === payload.project_analysis.model_title){
          return {...item , status: 'not_started'}
        }
        return item
      })
    },

    ADD_ITEM(state, value){
      state.items.push(value)
    },
  },

  actions: {
    all({ commit }, { projectId, config }){
      return $projectAnalysis._(projectId).all(config)
        .then(function(res){
          let {data, meta} = res.data
          commit('ITEMS', data)
          return res
        })
    },

    create({ commit }, { projectId, payload, config }){
      return $projectAnalysis._(projectId).create(payload, config)
      .then(res => {
        commit('ADD_ITEM', res.data)
        return res
      })
    },

    find({ commit }, { projectId, id, config }){
      return $projectAnalysis._(projectId).show(id, config)
      .then(res => {
        commit('ITEM', res.data.data)
        return res
      })
    },

    availableModels({ commit }, { projectId, id, config }){
      return $projectAnalysis._(projectId).availableModels(config)
      .then(res => {
        commit('AVAILABLE_MODELS', res.data.data.models)
        return res.data.data.models
      })
    },

    reset({commit}, {projectId, payload}){
      return $projectAnalysis._(projectId).reset(payload)
       .then(res => {
          commit('RESET', payload)
          return res
        })
    }

  }
}

export default module
